module.exports = __webpack_public_path__ + "img/1F1F8-1F1FE.9f595917.svg";